const numeric = value => (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) && Number.isFinite(Number(value))

export function bonusSettingsError(settings) {
  if (!settings) return ''
  if (settings.bonusChips != null && (!Array.isArray(settings.bonusChips) || !settings.bonusChips.length ||
    settings.bonusChips.some(chip => !chip || !numeric(chip.nominal) || Number(chip.nominal) <= 0))) {
    return 'Bonus chip denominations must be positive numbers.'
  }
  if (settings.bonusLimits == null) return ''
  if (typeof settings.bonusLimits !== 'object' || Array.isArray(settings.bonusLimits)) return 'Bonus limits must be an object.'
  const check = values => {
    for (const [key, value] of Object.entries(values)) {
      if (/(?:^|_)(min|max)$/.test(key)) {
        if (!numeric(value) || Number(value) < 0) return 'Bonus limits must be non-negative numbers: ' + key
        const maxKey = key.replace(/min$/, 'max')
        if (/(?:^|_)min$/.test(key) && values[maxKey] != null && Number(value) > Number(values[maxKey])) return 'Bonus minimum exceeds maximum: ' + key
      } else if (value && typeof value === 'object') {
        const error = check(value)
        if (error) return error
      }
    }
    return ''
  }
  return check({ ...settings.limit, ...settings.bonusLimits })
}

export const regularSettingsTabs = settings => Object.keys(settings || {}).filter(key => !['bonusChips', 'bonusLimits'].includes(key))
